import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  cHeader: {
    cursor: "pointer"
  },
  cOwnerInfoWrapper: {
    justifyContent: "center",
    padding: theme.spacing(1, 1, 0, 1),
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    overflow: "hidden"
  },
  cOwnerAvatar: {
    width: 100,
    marginRight: theme.spacing(1),
    borderTopLeftRadius: theme.spacing(0.25),
    borderTopRightRadius: theme.spacing(0.25),
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundImage: ({ avatar }) => avatar && `url(${avatar})`,
    backgroundSize: "contain",
    backgroundPosition: "bottom",
    backgroundRepeat: "no-repeat",
    boxShadow: theme.shadows[1],
    backgroundColor: "white",
    borderBottom: "none"
  },
  cOwnerInfo: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start"
  },
  cOwnerName: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    fontFamily: "Courier Prime",
    color: theme.palette.primary.main,
    textTransform: "uppercase",
    backgroundImage: "linear-gradient(120deg, #F4B793 0%, #F4B793 100%)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 0.2em",
    backgroundPosition: "0 88%",
    transition: "background-size 0.25s ease-in"
  },
  cLocation: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.primary.main,
    textTransform: "uppercase"
  }
}));
